<div class="plate__container linkedGoods ">
  <nb-card style="margin: 0">
    <nb-card-header style="border: none">
      {{ damRelatedCollection.header }}
      <span class="add">
        <button type="button" nbButton size="tiny" (click)="showSearchDamModal()">
          <nb-icon icon="plus-outline"></nb-icon>
        </button>
      </span>
    </nb-card-header>

    <nb-card-body>
      <ng-container *ngIf="damItemVersions?.length">
        <table class="ngx-table__table--tiny ngx-table">
          <thead>
          <tr>
            <th>Id</th>
            <th></th>
            <th>Название дам элемента</th>
            <th>Версия</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of damItemVersions">
            <td>
              {{ item.id }}
            </td>
            <td>
              <app-secured-image src="/dam/get-image-dynamic-version/{{item.id}}"/>
            </td>
            <td>
              <a href="/cabinet/dam/item/edit/{{item.damItem.id}}" target="_blank">{{ item.damItem.header || item.damItem.id }}</a>
            </td>
            <td>
              {{ item.iid }}
            </td>
            <td>
              <button type="button" status="control" nbButton size="small" (click)="removeVersionFromDamCollection(item.id,damRelatedCollection.id)">
                <nb-icon icon="close"/>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-container>
      <ng-container *ngIf="!damItemVersions?.length">
        <div style="margin-top: 5px">Нет связанных DAM-элементов</div>
      </ng-container>
    </nb-card-body>
  </nb-card>
</div>
